// import { combineReducers } from 'redux';

import { 
    POST_CREDENTIALS, 
    GET_CREDENTIALS, 
    GET_USER,
    GET_NEWS,
    UPDATE_USER, 
    GET_COURSES, 
    GET_USER_COURSES, 
    GET_COURSE_BY_PK,
    ADD_IN_PROGRESS_COURSE,
    GET_USER_PROGRESS_SUCCESS,
    MARK_VIDEO_COMPLETE_SUCCESS,
    LOGOUT_USER, 
    UNMARK_VIDEO_COMPLETE_SUCCESS
} from '../actions/actions.js';

const initialState = {
    credentials: {}, // Información de las credenciales del usuario. credentials: { username: '', password: '' }
    user: {}, // Información del usuario autenticado
    courses: [], // Cursos disponibles en la plataforma
    total: 0, // Total de cursos disponibles
    offset: 0, // Para paginación de cursos
    userCourses: [], // Cursos del usuario
    inProgressCourses: [], // Nuevo estado para cursos en proceso
    sessionCourse: {
        id: null, // Para almacenar el ID del curso actual en sesión
        name: '', // Para almacenar el nombre del curso actual en sesión
        progress: 0, // Para almacenar el progreso del curso actual en sesión
        description: '', // Para almacenar la descripción del curso actual en sesión
        videos: [], // Para almacenar los videos del curso actual en sesión
    }, // Para almacenar el curso actual en sesión
    sessionCourseProgress: {}, // Almacena el progreso del usuario en el curso actual. Ej: { videoId: { completed: true, progress: 120 } }
     news:[],

};

const Reducer = (state = initialState, action) => {
    switch (action.type) {
        case POST_CREDENTIALS:
            return {
                ...state,
                credentials: action.payload,
            };
        case GET_CREDENTIALS:
            return {
                ...state,
                credentials: action.payload,
            };
        case GET_USER:
            return {
                ...state,
                user: action.payload,
            };
        case UPDATE_USER:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload,
                },
            };
        case GET_COURSES:
            console.log('En el reducer',action.payload);
            
            return {
                ...state,
                courses: action.payload.courses,
                total: action.payload.total,
                offset: state.offset + action.payload.count,
            }
        // Manejo de cursos del usuario
        case GET_USER_COURSES:
            return {
                ...state,
                userCourses: action.payload,
            };


        // Nuevo caso para manejar el curso actual en sesión
        case GET_COURSE_BY_PK:
            return {
                ...state,
                sessionCourse: action.payload,
            };
        case ADD_IN_PROGRESS_COURSE:
            return {
                ...state,
                inProgressCourses: state.inProgressCourses.includes(action.payload)
                    ? state.inProgressCourses
                    : [...state.inProgressCourses, action.payload],
            };
        case GET_USER_PROGRESS_SUCCESS:
            return {
                ...state,
                sessionCourseProgress: action.payload,
            };
        case MARK_VIDEO_COMPLETE_SUCCESS:
            return {
                ...state,
                sessionCourseProgress: {
                    ...state.sessionCourseProgress,
                    [action.payload.videoId]: {
                        ...state.sessionCourseProgress[action.payload.videoId],
                        completed: true,
                    }
                }
            };
        case UNMARK_VIDEO_COMPLETE_SUCCESS:
            return {
                ...state,
                sessionCourseProgress: {
                    ...state.sessionCourseProgress,
                    [action.payload.videoId]: {
                        ...state.sessionCourseProgress[action.payload.videoId],
                        completed: false,
                    }
                }
            };

        case LOGOUT_USER:
            return {
                ...state,
                credentials: {},
                user: {},
            };
        case GET_NEWS:
            return{
                ...state,
                news: action.payload
            }
        default:
            return state;
    }
};


export default Reducer;
